import React from 'react';
import PropTypes from 'prop-types';
import css from './CwDropdownMulti.scss';
import CwCheckBox from '../cwcheckbox/CwCheckBox';

/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

class CwDropdownMultiItem extends React.Component {

  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.item);
    }
  };

  handleMouseEnter = (event) => {
    if (this.props.onMouseEnter) {
      this.props.onMouseEnter(this.props.index, { x: event.clientX, y: event.clientY });
    }
  };

  handleMouseDown = () => {
    if (this.props.onMouseDown) {
      this.props.onMouseDown(true);
    }
  };

  handleMouseMove = (event) => {
    if (this.props.onMouseMove) {
      this.props.onMouseMove({ x: event.clientX, y: event.clientY });
    }
  }

  render() {
    let itemStyle;
    if (this.props.isPicker) {
      itemStyle = this.props.isHighlighted ? css.dropDownHighlightedPicker : css.dropDownPicker;
    }
    else {
      itemStyle = this.props.isHighlighted ? css.dropDownHighlightedItem : css.dropDownItem;
    }
    return (
      <div className={itemStyle}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        ref={(div) => this.div = div}>
        <CwCheckBox text={this.props.item.name} value={this.props.isChecked} />
      </div>
    );
  }
}

CwDropdownMultiItem.propTypes = {
  /**
   * Determines whether the current dropdown item is highlighted
   */
  isHighlighted: PropTypes.bool,
  /**
   * Determines whether the current dropdown item is the picker
   */
  isPicker: PropTypes.bool,
  /**
   * The dropdown item being rendered. Must contain at least "id" and "name" fields.
   */
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }),
  /**
   * Callback function that is fired when dropdown item is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired when dropdown item is hovered over.
   */
  onMouseEnter: PropTypes.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown item from derezzing before a selection is registered.
   */
  onMouseDown: PropTypes.func,
  /**
   * The index of the dropdown item being rendered.
   */
  index: PropTypes.number,
  isChecked: PropTypes.bool
};

CwDropdownMultiItem.defaultProps = {
  item: { id: null, name: null }
};

export default CwDropdownMultiItem;


// WEBPACK FOOTER //
// ./src/components/cwdropdown/CwDropdownMultiItem.jsx